<forge-card *ngIf="!isDrillIn" class="calendar-card no-padding">
    <h2 *ngIf="hasTitle" attr.slot="header"
        class="forge-typography--heading2 tt-padding-top-sm tt-padding-bottom-sm tt-padding-left-md tt-padding-right-md">
        {{title}}
    </h2>
    <forge-divider></forge-divider>
    <div fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="center flex-start" class="calendar-container tt-padding-bottom-sm"
             [ngClass]="{'calendar-disabled': isDisabled}">
            <metadata-calendar-month *ngFor="let month of calendarMonths" [calDate]="month"
                                     (toggleDrillIn)="toggleDrillIn($event.date)" [parent]="parent"
                                     [metadataModel]="metadataModel" [propertyMetadata]="propertyMetadata"
                                     [formRepository]="formRepository" [model]="model" style="margin: 0.5rem;">
            </metadata-calendar-month>
        </div>
        <forge-divider></forge-divider>
        <div fxLayout="row" fxLayoutAlign="center center" layout-wrap class="tt-padding-left-sm tt-padding-right-sm">
            <div *ngFor="let item of calendarKey; trackBy: trackByFn">
                <div fxLayout="row" class="calendar-key">
                    <div class="calendar-key--color event-color-{{item.Color}}"></div>
                    <div class="forge-typography--label1">{{item.DateKey}}</div>
                </div>
            </div>
        </div>
    </div>
</forge-card>
<metadata-calendar-month *ngIf="isDrillIn" fxFlex="100" [model]="model" [parent]="parent"
                         [metadataModel]="metadataModel" (toggleDrillIn)="toggleDrillIn()"
                         [formRepository]="formRepository" [propertyMetadata]="propertyMetadata"
                         [startDate]="drillStartDate" [isDrillIn]="isDrillIn" [viewOnly]="viewOnly">
</metadata-calendar-month>
